<template>
  <div class="home-hero-container">
    <div class="home-hero">
      <TopLunbo />
	
      <!-- <BottomInfo /> -->
    </div>
  </div>
</template>

<script>
import TopLunbo from './TopLunbo'
import BottomInfo from './BottomInfo'


export default {
  name: "index",
  components: {
    TopLunbo,
    BottomInfo
  },
};
</script>

<style lang="less" scoped>
.home-hero-container {
  position: relative;
  z-index: 10;
  .home-hero{
    height: 644px;

  }
}
.container {
  // width: 1226px;
  margin-right: auto;
  margin-left: auto;
}
</style>